import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { useCached } from "../lib/dataCache";
import { Card, CardContent } from "../components/ui/card";
import { ShieldCheck } from "lucide-react";

export default function AuditLog() {
  const [logs, setLogs] = useCached("audit_logs", []);
  useEffect(() => { api.get("/audit-logs").then(r => setLogs(r.data)).catch(() => {}); }, []);
  return (
    <div className="space-y-6" data-testid="audit-log-page">
      <div>
        <div className="text-xs uppercase tracking-[0.2em] text-neutral-500 font-semibold">Keamanan</div>
        <h1 className="font-display text-3xl md:text-4xl font-bold text-neutral-900 mt-1">Jejak Audit</h1>
        <p className="text-sm text-neutral-500 mt-1">Catatan aksi penting oleh semua pengguna (khusus Owner).</p>
      </div>
      <Card className="border-neutral-200 shadow-none"><CardContent className="p-0 divide-y">
        {logs.length === 0 && <div className="p-8 text-center text-neutral-500" data-testid="audit-empty">Belum ada aktivitas tercatat.</div>}
        {logs.map(l => (
          <div key={l.id} className="p-3 flex items-start gap-3 text-sm" data-testid="audit-row">
            <ShieldCheck className="w-4 h-4 text-neutral-400 mt-0.5 shrink-0" />
            <div className="min-w-0">
              <div className="font-medium text-neutral-900">{l.action} · <span className="text-neutral-500">{l.entity}</span></div>
              {l.detail && <div className="text-xs text-neutral-500 break-words">{l.detail}</div>}
              <div className="text-[11px] text-neutral-400 mt-0.5">{l.user_email} ({l.user_role}) · {l.created_at ? new Date(l.created_at).toLocaleString("id-ID") : ""}</div>
            </div>
          </div>
        ))}
      </CardContent></Card>
    </div>
  );
}
